export class VideoJsGoogleAnalytics {
    static reportVidoeStartPlaying = (videoSrc) => {
        const dataLayer = window.dataLayer || []
        dataLayer.push({
            event: "video_start",
            related_url: `${window.video_ad_description_url}&dcPath=${window.dcPath}`,
            video_url: `${videoSrc}&source=${window.video_analytics_src}`
        });
    }
}